<svg
	[attr.viewBox]="getViewBox()"
	[attr.width]="getWidth() + 'px'"
	[attr.height]="getHeight() + 'px'"
	preserveAspectRatio="none"
	[class]="'style-' + style().toLowerCase()"
>
	@if (yAxis().ticks.length > 0 && style() === "BAR") {
		<line class="axis" [attr.x1]="paddingLeft()" [attr.y1]="paddingTop()" [attr.x2]="paddingLeft()" [attr.y2]="barHeight() + paddingTop()"></line>
	}
	@for (partition of partitions(); let i = $index; track i) {
		<g [attr.transform]="getBarTransform(i)">
			@for (area of getSVGAreas(i); track $index) {
				<g class="areas">
					<rect [attr.x]="0" [attr.y]="area.y" [attr.width]="barSpace()" [attr.height]="area.height" [attr.class]="area.className"></rect>
				</g>
			}
			<rect
				class="tooltip"
				x="0"
				[attr.y]="-barHeight()"
				[attr.width]="barSpace()"
				[attr.height]="barHeight()"
				[appTooltip]="partition.tooltip"
				[tooltipClass]="tooltipClass()"
			></rect>
		</g>
	}
	<g [attr.transform]="getYAxisTransform()" class="y-axis">
		@if (style() !== VbarStyle.PLANE) {
			@for (tick of getSVGTicks(); let i = $index; track i) {
				<line
					[class.axis]="i === 0 || tick.y === 0"
					x1="-3"
					[attr.y1]="tick.y"
					[attr.x2]="getWidth() - paddingLeft()"
					[attr.y2]="tick.y"
				></line>
			}
		}
		@for (tick of getSVGTicks(); track $index) {
			<g>
				<text [attr.x]="-5" [attr.y]="tick.y" text-anchor="end" dominant-baseline="middle">{{ tick.label }}</text>
			</g>
		}
	</g>
	<g>
		@for (measure of measures; let i = $index; track i) {
			<g [attr.transform]="getMeasureTransform(i)">
				<text x="0" y="0" text-anchor="middle" dominant-baseline="middle" (click)="onTextClick(i)" class="measure">{{ measure }}</text>
			</g>
		}
	</g>
	@if (style() === VbarStyle.CIRCLE) {
		@for (partition of partitions(); let i = $index; track i) {
			<g [attr.transform]="getBarTransform(i)">
				@if (partition.qty !== null) {
					<circle r="4" [attr.cx]="0.5 * barSpace()" [attr.cy]="-qtyToPx(partition.qty)"></circle>
				}
			</g>
		}
	}
	@if (style() === VbarStyle.BAR || style() === VbarStyle.PLANE) {
		@for (bars of pctStacks; let i = $index; track i) {
			<g [attr.transform]="getPartitionTransform(i)" class="partition">
				@if (style() === VbarStyle.PLANE) {
					<clipPath [id]="getPartitionClipPathId(i)">
						<rect
							[attr.x]="rectPaddingPx()"
							[attr.y]="partitionClipY(i)"
							[attr.width]="rectWidthPx()"
							[attr.height]="partitionClipHeight(i)"
							[attr.rx]="3"
							[attr.ry]="3"
						></rect>
					</clipPath>
				}
				@for (bar of bars; let j = $index; track j) {
					<g class="bar" [attr.clip-path]="style() === VbarStyle.PLANE ? 'url(#' + getPartitionClipPathId(i) + ')' : undefined">
						<clipPath [id]="getClipPathId(i, j)">
							<rect
								[attr.x]="rectPaddingPx()"
								[attr.y]="barY(bar.pctStart, bar.pct, i)"
								[attr.width]="rectWidthPx()"
								[attr.height]="barPxHeight(bar.pct, i)"
							></rect>
						</clipPath>
						<rect
							[appTooltip]="bar.tooltip"
							[attr.x]="rectPaddingPx()"
							[attr.y]="barY(bar.pctStart, bar.pct, i)"
							[attr.width]="rectWidthPx()"
							[attr.height]="barPxHeight(bar.pct, i)"
							[class]="bar.className"
							(click)="onBarClick(bar)"
							[class.clickable]="bar.selection || bar.clickHandler"
						></rect>
						@if (barPxHeight(bar.pct, i) >= textLineHeight) {
							<g [attr.clip-path]="'url(#' + getClipPathId(i, j) + ')'">
								<text
									class="bar-text"
									x="0"
									y="0"
									text-anchor="middle"
									dominant-baseline="middle"
									[attr.transform]="getTextTransform(i, bar.pctStart, bar.pct)"
								>
									{{ bar.text }}
								</text>
							</g>
						}
					</g>
				}
			</g>
			@if (bars.length > 0 && shouldShowTextOutsidePartition(i, bars[0].pct)) {
				<text
					class="bar-text outside-clip-path"
					x="0"
					y="0"
					text-anchor="middle"
					dominant-baseline="middle"
					[attr.transform]="getTextTransformOutsidePartition(i)"
					[appTooltip]="bars[0].tooltip"
					(click)="onBarClick(bars[0])"
					[class.clickable]="bars[0].selection"
				>
					{{ bars[0].text }}
				</text>
			}
		}
		@if (options()?.showPartitionRectangle) {
			<g>
				@for (r of getPartitionRectangles(); track $index) {
					<rect [attr.x]="r.x" [attr.y]="r.y" [attr.width]="r.width" [attr.height]="r.height" class="partition-rectangle"></rect>
				}
			</g>
		}
	}
	<g [attr.transform]="getXAxisTransform()" class="x-axis">
		@if (style() !== VbarStyle.PLANE && yAxis().ticks.length === 0) {
			<line class="axis" x1="0" y1="0" [attr.x2]="getWidth()" y2="0"></line>
		}
		@for (xlabel of xlabels; let i = $index; track i) {
			<g [attr.transform]="'translate(' + (i + 0.5) * barSpace() + ' 0)'">
				@switch (style()) {
					@case (VbarStyle.BAR) {
						<line x1="0" y1="0" x2="0" y2="3"></line>
						<g transform="translate(0 5) rotate(270)">
							<text x="0" y="0" text-anchor="end" dominant-baseline="middle" [class]="xlabel.className">{{ xlabel.label }}</text>
						</g>
					}
					@case (VbarStyle.CIRCLE) {
						<g transform="translate(0 5) rotate(270)">
							<text x="0" y="0" text-anchor="end" dominant-baseline="middle" [class]="xlabel.className">{{ xlabel.label }}</text>
						</g>
					}
					@case (VbarStyle.PLANE) {
						<g transform="translate(0 5)">
							@if (xlabel.className === "voorlopig") {
								<text x="-7" y="0" text-anchor="middle" dominant-baseline="hanging" [class]="xlabel.className">
									{{ xlabel.label }}
								</text>
								<g [attr.transform]="'translate(' + getVoorlopigIconX(xlabel.label) + ', 1) scale(0.625)'">
									<!-- dit is Trend.svg, inlined omdat anders de image export het niet doet  -->
									<path
										d="M11.798 4.01772L12.9751 5.17709L8.98593 9.10607L6.29648 6.45723C6.14376 6.30647 5.93641 6.22175 5.72017 6.22175C5.50394 6.22175 5.29659 6.30647 5.14387 6.45723L0.239107 11.296C-0.0797023 11.61 -0.0797023 12.1172 0.239107 12.4312C0.557916 12.7452 1.07292 12.7452 1.39173 12.4312L5.71609 8.16408L8.40553 10.8129C8.72434 11.1269 9.23934 11.1269 9.55815 10.8129L14.1277 6.32036L15.3049 7.47973C15.5583 7.72932 15.9997 7.55219 15.9997 7.19794V3.73593C16.0079 3.5105 15.8281 3.33337 15.5992 3.33337H12.0923C11.7244 3.33337 11.5446 3.76814 11.798 4.01772Z"
										fill="#3B4D68"
									/>
								</g>
							} @else {
								<text x="0" y="0" text-anchor="middle" dominant-baseline="hanging" [class]="xlabel.className">
									{{ xlabel.label }}
								</text>
							}
						</g>
					}
				}
			</g>
		}
		@for (i of xrangeIncl; track i) {
			<g [attr.transform]="'translate(' + i * barSpace() + ' 0)'">
				@if (style() === "CIRCLE") {
					<line x1="0" y1="3" x2="0" [class.axis]="i === 0" [attr.y2]="-barHeight()"></line>
				}
			</g>
		}
	</g>
</svg>
